import { useState, createContext } from 'react';
import {
  createInvestment,
  listInvestments,
  updateInvestment,
  deleteInvestment
} from '../api/investments';

export const InvestimentosContext = createContext({});

function InvestimentosProvider({ children }) {
  const [investimentos, setInvestimentos] = useState([]);

  async function saveInvestimentos(payload) {
    const inv = await createInvestment(payload);
    setInvestimentos(prev => [...prev, inv]);
    getInvestimentos(payload.userId);
  }

  async function getInvestimentos(userId) {
    try {
      const list = await listInvestments(userId);
      setInvestimentos(list);
    } catch (err) {
      console.error('Erro ao buscar investimentos:', err);
    }
  }

  async function excluirInvestimento(id, userId) {
    await deleteInvestment(id);
    getInvestimentos(userId);
  }

  async function updateInvestimentoValues(data) {
    await updateInvestment(data._id, data);
    getInvestimentos(data.userId);
  }

  return (
    <InvestimentosContext.Provider
      value={{
        investimentos,
        saveInvestimentos,
        getInvestimentos,
        excluirInvestimento,
        updateInvestimentoValues
      }}
    >
      {children}
    </InvestimentosContext.Provider>
  );
}

export default InvestimentosProvider;
